import axiosInstance from "@/api/axios-instance";

export async function sendPrescription(prescriptionId: string) {
  try {
    const response = await axiosInstance.post(
      `/prescriptions/${prescriptionId}/send`
    );

    if (!response.status.toString().startsWith("2")) {
      throw new Error(response.data.error || "Failed to send prescription");
    }

    return response.data;
  } catch (error: any) {
    console.error("Error sending prescription:", error);
    if (error.response) {
      throw new Error(
        error.response.data?.message || error.response.data?.error || "Failed to send prescription"
      );
    }
    throw error;
  }
}
